import { useMemo } from 'react';
import OptionsList from 'components/OptionsList';
import { OptionItem } from 'components/OptionsList/types';
import { useExportTranscriptModalContext } from './ExportTranscriptModalContext';
import SpeakerLabelFormatting from './SpeakerLabelFormatting';
import { checkIsFileTypeUnsupportedForSpeakerLabelFormatting } from './utils';

export interface SpeakerLabelFormattingOptionsProps {}

const SpeakerLabelFormattingOptions: React.FC<
  SpeakerLabelFormattingOptionsProps
> = () => {
  const {
    format,
    downloadFormatting: { includeSpeakerLabels },
    onDownloadFormattingChange,
  } = useExportTranscriptModalContext();

  const labelFormattingItems = useMemo((): OptionItem[] => {
    return [
      {
        key: 'includeSpeakerLabels',
        value: includeSpeakerLabels,
        label: 'Include speaker labels',
        subOptions: checkIsFileTypeUnsupportedForSpeakerLabelFormatting(
          format,
        ) ? null : (
          <SpeakerLabelFormatting />
        ),
      },
    ];
  }, [format, includeSpeakerLabels]);

  return (
    <OptionsList
      label="Speaker label formatting"
      items={labelFormattingItems}
      onChange={onDownloadFormattingChange}
    />
  );
};

export default SpeakerLabelFormattingOptions;
